(() => {
  if (window.tbrLeadClicksReady) return;
  window.tbrLeadClicksReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    let name;
    if (href.startsWith('tel:')) name = 'tbr_phone_click';
    else if (href.startsWith('mailto:')) name = 'tbr_email_click';
    else { try { const url = new URL(href, location.origin); if (url.origin === location.origin && url.pathname === '/pages/request-itad-assessment') name = 'tbr_assessment_click'; } catch (_) { return; } }
    if (!name) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event:name, page_path:location.pathname});
  });
})();
